/* eslint-disable import/newline-after-import */
/* eslint-disable default-param-last */
/* eslint-disable sonarjs/no-small-switch */
/* eslint-disable prettier/prettier */
import t from "../../Actions/QuickPermitActions/types";
const initialState = {
  quickPermitLot: null,
};

const QuickPermitReducer = (state = initialState, action) => {
  switch (action.type) {
    case t.GET_QUICK_PERMIT_LOT:{
      return { ...state, quickPermitLot: action.payload };
    }
    default:
      return state;
  }
};

export default QuickPermitReducer;
